import 'selectize';

export default (function (w, d) {
    'use strict';

    function Select() {
        this.init();
    }

    Select.prototype.init = function () {
        $('.selectize-here').selectize();
    }

    return Select;
}(window, document));

